import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/gif/genesis-loading.gif'


const _hoisted_1 = { class: "relative bg-white text-center flex-col py-6 px-12 flex rounded-lg" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "pt-10 pb-3 px-12" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "h-36 w-36",
    alt: "loading",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "text-12px xxl:text-14px pb-10 text-center font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        ref: "modal",
        tabindex: "0",
        class: ["justify-center items-center flex", _ctx.isModal ? 'bg-overlay fixed inset-0 z-70' : '']
      }, [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.message || (_ctx.isAuth ? _ctx.$t("loading") : "Your Request is In Progress")), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}